import React from 'react';
import './Loader.css';

const Loader = ({ minDisplay = true }) => {
  return (
    <div className={`msquare-global-loader ${minDisplay ? 'is-visible' : ''}`} role="status" aria-live="polite">
      <div className="loader-backdrop-glow" aria-hidden="true" />
      <div className="loader-inner">
        <div className="loader-logo-wrap">
          <img
            src={`${process.env.PUBLIC_URL}/assets/msquare-logo.png`}
            alt="M Square"
            className="loader-logo-img"
            onError={(e) => {
              e.currentTarget.style.display = 'none';
            }}
          />
          <div className="loader-spinner-ring" aria-hidden="true" />
        </div>

        <div className="loader-brand-title">
          <span className="brand-top">M SQUARE</span>
          <span className="brand-bottom">PROFESSIONALS</span>
        </div>

        <div className="loader-progress-bar" aria-hidden="true">
          <div className="loader-progress-fill" />
        </div>
      </div>
    </div>
  );
};

export default Loader;
